import * as React from 'react';
import { FormattedMessage } from 'react-intl';
import { Item } from '../../../../components/Grid';
import HistoryRowControls from '../../../../components/HistoryRowControls';
import HistoryRowListing from '../../../../components/HistoryRowListing';
import { formatPartialDate } from 'Utility/date';
import InfoPopover from 'Components/InfoPopover';
import HistoryHeader from 'Components/_NewElements/HistoryHeader';
import { Doc_Progress, IMGADL, mgadl } from 'neuro-schemas';

const isFilledMgadl = (doc: IMGADL): boolean => mgadl.calculateProgress(doc).state === Doc_Progress.State.Completed;

const MGADLHistory = ({ documents, startEdit, view }: IOwnProps): React.JSX.Element => (
  <>
    <HistoryHeader
      headerText={<FormattedMessage id="functionalPerformanceMgravis.mgadl" />}
      buttons={[{ text: 'functionalPerformanceMgravis.newmgadl', onClick: startEdit({}, 'mgadl') }]}
    />
    <HistoryRowListing
      documents={documents}
      headers={
        <>
          <Item xs={2}>
            <FormattedMessage id="general.date" />
          </Item>
          <Item xs={2}>
            <FormattedMessage id="functionalPerformanceMgravis.mgadlScore" />
          </Item>
          <Item xs={8}>&nbsp;</Item>
        </>
      }
      contentFormat={(d: IMGADL & IControlProps): React.JSX.Element => (
        <>
          <Item xs={2}>{formatPartialDate(d.date ?? undefined)}</Item>
          <Item xs={2}>
            {isFilledMgadl(d) ? (
              mgadl.calculateProgress(d).yielded
            ) : (
              <InfoPopover text="general.notFilled" color="primary" />
            )}
          </Item>
          <Item xs={5}>&nbsp;</Item>
          <Item xs={3}>
            <HistoryRowControls document={d} startEdit={startEdit} view={view} />
          </Item>
        </>
      )}
    />
  </>
);

interface IOwnProps {
  documents: Array<IMGADL & IControlProps>;
  startEdit: (document: TAnyObject, name?: string) => (e: React.MouseEvent<Element, MouseEvent>) => void;
  view?: IView;
}

export default MGADLHistory;
